const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';

function randomChars(length: number): string {
  const cryptoObj = (globalThis as { crypto?: { getRandomValues?: (a: Uint8Array) => Uint8Array } })
    .crypto;
  const bytes = new Uint8Array(length);
  if (cryptoObj?.getRandomValues) cryptoObj.getRandomValues(bytes);
  else for (let i = 0; i < length; i++) bytes[i] = Math.floor(Math.random() * 256);
  return Array.from(bytes, (b) => ALPHABET[b % ALPHABET.length]).join('');
}

/** Time-ordered unique id (ULID-like) for command requestIds and trace ids. */
export function newRequestId(): string {
  return `${Date.now().toString(36)}${randomChars(10)}`;
}

export const newTraceId = (): string => randomChars(16);
